// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"159":"pay-result","982":"product-detail"}[chunkId] + "." + {"159":"664b3cdd","982":"6828cc0e"}[chunkId] + ".css";
};